import { render, staticRenderFns } from "./DosMediaU3.vue?vue&type=template&id=c047c274&scoped=true&"
import script from "./DosMediaU3.vue?vue&type=script&lang=js&"
export * from "./DosMediaU3.vue?vue&type=script&lang=js&"
import style0 from "./DosMediaU3.vue?vue&type=style&index=0&id=c047c274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c047c274",
  null
  
)

export default component.exports